// 1-слоты,
// 2-ставки,
// 3-Быстрые,
// 4-Live дилер,
// 5-Настольные,
// 6-Избранное,
// 7-Казино,
// 9-Статус,
// 10-Кешбэк,
// 11-Бонусы,
// 12-Телеграм,
// 13-Промокоды
// 14-поддержка,
// 15-магазин,

// 16-меню,
// 17-игры,
// 18-поддержка,
// 19-профиль,
// 20-беттинг
// 21-беттинг sports
// 22-беттинг live
// 23-беттинг результаты

const BANNERS_DATA = [
  {
    id: 1,
    image: '/images/icons/minibanners_new/slots.png',
    param: 'slots',
    tKey: 'mini_games_banners.slots',
  },
  {
    id: 2,
    image: '/images/icons/minibanners_new/bids.png',
    param: 'betting',
    tKey: 'common.footer.betting',
  },
  {
    id: 3,
    image: '/images/icons/minibanners_new/fast.png',
    param: 'instant',
    tKey: 'mini_games_banners.fast',
  },
  {
    id: 4,
    image: '/images/icons/minibanners_new/liveDealer.png',
    param: 'live',
    tKey: 'mini_games_banners.dealer',
  },
  {
    id: 5,
    image: '/images/icons/minibanners_new/desktop.png',
    param: 'table',
    tKey: 'mini_games_banners.table',
  },
  {
    id: 6,
    image: '/images/icons/minibanners_new/favourites.png',
    param: 'favorite',
    tKey: 'mini_games_banners.wishlist',
  },
  {
    id: 7,
    image: '/images/icons/minibanners_new/casino.png',
    param: 'games',
    tKey: 'minibanners.games',
  },
  {
    id: 9,
    image: '/images/icons/minibanners_new/status.png',
    param: 'status',
    tKey: 'minibanners.status',
  },
  {
    id: 10,
    image: '/images/icons/minibanners_new/cashback.png',
    param: 'cashback',
    tKey: 'minibanners.cashback',
  },
  {
    id: 11,
    image: '/images/icons/minibanners_new/bonuses.png',
    param: 'profile/bonuses',
    tKey: 'minibanners.bonus',
  },
  {
    id: 12,
    image: '/images/icons/minibanners_new/telegram.png',
    param: 'https://t.me/pingwincasino',
    tKey: 'minibanners.telegram',
  },
  {
    id: 13,
    image: '/images/icons/minibanners_new/promoCodes.png',
    param: 'promocodes',
    tKey: 'menu_banner.promo',
  },
  {
    id: 14,
    image: '/images/icons/minibanners_new/support.png',
    param: 'support',
    tKey: 'common.footer.support',
  },
  {
    id: 15,
    image: '/images/icons/minibanners_new/shop.png',
    param: 'shop',
    tKey: 'menu_banner.shop',
    disabled: true,
  },
  {
    id: 16,
    image: '/images/icons/menu_new/menu.svg',
    srcActive: '/images/icons/menu_new/menu_active.svg',
    param: 'menu',
    tKey: 'common.footer.menu',
  },
  {
    id: 17,
    image: '/images/icons/menu_new/games.svg',
    srcActive: '/images/icons/menu_new/games_active.svg',
    param: 'games',
    tKey: 'common.footer.games',
  },
  {
    id: 18,
    image: '/images/icons/menu_new/support.svg',
    srcActive: '/images/icons/menu_new/support_active.svg',
    param: 'support',
    tKey: 'common.footer.support',
  },
  {
    id: 19,
    image: '/images/icons/menu_new/profile.svg',
    srcActive: '/images/icons/menu_new/profile_active.svg',
    param: 'profile',
    tKey: 'common.footer.profile',
  },
  {
    id: 20,
    image: '/images/icons/menu_new/sport.svg',
    srcActive: '/images/icons/menu_new/sport_active.svg',
    param: 'betting',
    tKey: 'common.footer.betting',
  },
  {
    id: 21,
    image: '/images/icons/minibanners_new/bets_sport.png',
    param: 'betting_sports',
    tKey: 'mini_games_banners.bets_sport',
  },
  {
    id: 22,
    image: '/images/icons/minibanners_new/bets_live.png',
    param: 'betting_live',
    tKey: 'mini_games_banners.bets_live',
  },
  {
    id: 23,
    image: '/images/icons/minibanners_new/bets_result.png',
    param: 'betting_result',
    tKey: 'mini_games_banners.bets_results',
  },
  {
    id: 24,
    image: '/images/icons/minibanners_new/fortune-wheel.png',
    param: 'fortune-wheel',
    tKey: 'minibanners.wheel',
  },
];

const SORT_CONFIG_BANNERS = {
  unauthenticated: {
    desktop: {
      main: [7, 2, 10, 9, 12, 13],
      games: [1, 2, 3, 4, 5],
      betting: [21, 22, 23, 7, 10, 9],
    },
    mobile: {
      main: [10, 9, 12],
      games: [1, 2, 3, 4, 5],
      betting: [21, 22, 23, 10, 9, 12],
    },
  },
  authenticated: {
    desktop: {
      main: [7, 6, 2, 11, 10, 9, 24, 13, 12],
      games: [1, 6, 2, 3, 4, 5],
      betting: [21, 22, 23, 7, 11, 10],
    },
    mobile: {
      main: [6, 11, 10, 9, 24, 13, 12],
      games: [1, 6, 2, 3, 4, 5],
      betting: [21, 22, 23, 7, 11, 10, 9, 24, 13, 12],
    },
  },
  mobileMenuModal: [7, 2, 9, 24, 10, 11, 6, 12, 14, 15],
  mobileMenu: [16, 17, 20, 18, 19],
};

export { BANNERS_DATA, SORT_CONFIG_BANNERS };
